import { useQuery } from "@apollo/client";
import get from "lodash/get";

import { PAGINATION_SIZE } from "../constants";

const useLoadMoreQuery = ({ queryName, type, filter, ...options }) => {
  const query = useQuery(queryName, {
    variables: filter,
    ...options,
  });
  const onLoadMore = () => {
    const length = get(query, `data.${type}.data`, []).length;
    query
      .fetchMore({
        variables: {
          where: {
            ...filter?.where,
            range: `${length + 1}-${length + PAGINATION_SIZE}`,
          },
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return prev;
          }
          return {
            ...prev,
            [type]: {
              ...prev[type],
              data: [...prev[type].data, ...fetchMoreResult[type].data],
            },
          };
        },
      })
      .catch(() => {});
  };
  return { query, onLoadMore };
};

export default useLoadMoreQuery;
